const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  access_denied: "Authorization was denied",
  invalid_state: "Session expired, please try again",
  missing_code: "Authorization failed — no code received",
  token_exchange_failed: "Connection failed, please try again",
}

const OAUTH_SUCCESS_MESSAGES: Record<string, string> = {
  gmail: "Gmail account connected",
  microsoft: "Microsoft account connected",
}

export function getOAuthErrorMessage(error: string): string {
  return OAUTH_ERROR_MESSAGES[error] || `Connection error: ${error}`
}

export function getOAuthSuccessMessage(provider: string): string {
  return OAUTH_SUCCESS_MESSAGES[provider] || `${provider} account connected`
}
